import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ProductLabel } from '@/types/productServerApi';
import SplashLabel from '@/shared/content/blocks/helpers/SplashLabel.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSplashLabelProductSpot',
  props: {
    label: null,
    selected: { type: Boolean },
    recommended: { type: Boolean },
    hasHighPriorityLabel: { type: Boolean }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (!!__props.label && !__props.selected && !__props.recommended)
    ? (_openBlock(), _createBlock(SplashLabel, {
        key: 0,
        class: "bg-brandy",
        "background-color": __props.label.backgroundColorHex,
        label: __props.label.text
      }, null, 8, ["background-color", "label"]))
    : _createCommentVNode("", true)
}
}

})